import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SignupService } from '../common-service/signup.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { encryptionService } from '../../app/common-service/cedService';
import { PtrService } from 'src/app/ptr';
import { ToastrService } from 'ngx-toastr';
import { HelperService } from 'src/app/common-service/helper.service';
import { interval } from 'rxjs';
@Component({
  selector: 'app-register1',
  templateUrl: './register1.component.html',
  styleUrls: ['./register1.component.scss']
})
export class RegisterComponent1 implements OnInit {
  submitted = false;
  redirectPageCounter = 10;
  stateName = false;
  cityName = false;
  constructor(public tostar: ToastrService,public router: Router, private formBuilder: FormBuilder,
    public helper: HelperService, public signin: PtrService, private spinner: NgxSpinnerService, 
    public ced: encryptionService, private toastr: ToastrService, private signup: SignupService) { }
  formGroupId = this.formBuilder.group({
    name: ['', Validators.compose([Validators.required])],
    userEmail: ['', Validators.compose([Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)])],
    addressLine1: ['', Validators.compose([Validators.required])],
    addressLine2: [''],
    countryId: ['', Validators.compose([Validators.required])],
    stateId: ['',Validators.compose([Validators.required])],
    cityId: ['',Validators.compose([Validators.required])],
    pinCode: ['', Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(6)])],
    mobileNumber: ['', Validators.compose([Validators.required, Validators.pattern('[6-9]\\d{9}')])],
    landlineNumber: [''],
    stateName: ['',Validators.compose([Validators.required])],
    cityName: ['',Validators.compose([Validators.required])],
    institutionTypeId: ['',Validators.compose([Validators.required])]
  });
  get f() { return this.formGroupId.controls; }
  countryList: any = [];
  stateList: any = [];
  cityList: any = [];
  allstateList: any = [];
  allcityList: any = [];
  institutionTypeList: any = [];
  findState() {
    let countryId = this.formGroupId.value.countryId;
    if(countryId==="1" || countryId===1){
      this.stateName=false;
      this.cityName=false;
      //DISABLE VALIDATION FOR TEXT BY SUGAND
      this.formGroupId.controls.stateName.clearValidators();
      this.formGroupId.controls['stateName'].updateValueAndValidity();
      this.formGroupId.controls.cityName.clearValidators();
      this.formGroupId.controls['cityName'].updateValueAndValidity();

      this.formGroupId.controls.stateId.setValidators(Validators.required);
      this.formGroupId.controls.cityId.setValidators(Validators.required);


      this.stateList = this.allstateList.filter(function (item) {
        return item.country.countryId == parseInt(countryId);
      });
    }else{
      this.stateName=true;
      this.cityName=true;
      //DISABLED 
      this.formGroupId.controls.stateId.clearValidators();
      this.formGroupId.controls['stateId'].updateValueAndValidity();
      this.formGroupId.controls.cityId.clearValidators();
      this.formGroupId.controls['cityId'].updateValueAndValidity();

      this.formGroupId.controls.stateName.setValidators(Validators.required);
      this.formGroupId.controls.cityName.setValidators(Validators.required);
    }
   
  }
  findCity() {
    let stateId = this.formGroupId.value.stateId;
    this.cityList = this.allcityList.filter(function (item) {
      if(item.state !==null && item.state.stateId!==""){
        return item.state.stateId == parseInt(stateId);
      }
     
    });
  }
  ngOnInit() {
    this.clearSession();
    this.signin.institutionTypeList().subscribe((result: any) => {
      this.institutionTypeList = result;
      this.institutionTypeList = this.institutionTypeList.filter(
        institute => institute.institutionTypeId!=7);
      
    }, error => {

    });

    this.signin.countryList().subscribe((result: any) => {
      this.countryList = result;
      this.countryList = this.countryList.filter(
        country => country.countryId === 1);
    }, error => {

    });

    this.signin.stateList().subscribe((result: any) => {
      this.allstateList = result;
      this.formGroupId.controls.countryId.setValue(1);
      this.findState();
    }, error => {

    });

    this.signin.cityList().subscribe((result: any) => {
      this.allcityList = result;
    }, error => {

    });
   


    
    

  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.formGroupId.invalid) {
      return;
    }


    this.spinner.show();
    let ecApplicantSignUpObj = Object.assign({}, this.formGroupId.value)
    let ecUserSignUp = { 'applicantName': ecApplicantSignUpObj['name'], 'emailId': ecApplicantSignUpObj['userEmail'] }
    this.signin.applicantSignUp(ecUserSignUp).subscribe((data: any) => {
      if (data.response.respcode == '2000') {
        this.ced.encryptingProcess('access-token', data.access_token);
        this.ced.encryptingProcess('refresh-token', data.refresh_token);
        ecApplicantSignUpObj['oAuthUserId'] = data.oAuthUserId
        this.submitRegistration(ecApplicantSignUpObj);
      } else if (data.response.respcode == '500') {
        this.spinner.hide();
        this.displayErrorMsg('error', data.response.message);
        this.clearSession();
      } else {
        this.spinner.hide();
        this.displayErrorMsg('error', 'Applicant Signup is Failed!!');
        this.clearSession();
      }
    }, error => {
      this.spinner.hide();      
      error.status = error.status == 0 ? 500 : error.status
      console.log(error);
      this.clearSession();
    });


  }

  private submitRegistration(ecApplicantRegObj: any) {
    if (ecApplicantRegObj) {
      ecApplicantRegObj.countryId = parseInt(ecApplicantRegObj.countryId);
      ecApplicantRegObj.stateId = parseInt(ecApplicantRegObj.stateId);
      ecApplicantRegObj.cityId = parseInt(ecApplicantRegObj.cityId);
      ecApplicantRegObj.institutionTypeId = parseInt(ecApplicantRegObj.institutionTypeId);
      // ecApplicantRegObj.applicationStatus = 'SAVEASDRAFT';
      ecApplicantRegObj.status = 'SAD';
      this.signin.SaveRegistation(ecApplicantRegObj).subscribe((data: any) => {
        this.clearSession();
        this.spinner.hide();
        if (data.response.respcode == '200') {
          this.tostar.success('Registered successfully', 'Success', {
            timeOut: 2000
          });
          //this.startCounterToRedirect();
          this.redirectTo();
        } else if (data.response.respcode == '500') {
          this.displayErrorMsg('error', data.response.message);
        } else {
          this.displayErrorMsg('error', 'Applicant Registration is Failed!!');
        }
      }, error => {
        this.spinner.hide();
        error.status = error.status == 0 ? 500 : error.status
        this.helper.errorMessage(error);
        this.clearSession();
      });
    }
  }
  fieldTextType: boolean;
  confirmfieldTextType: boolean;
  private startCounterToRedirect() {
    const numbers = interval(1000);
    const redirectSubscriber = numbers.subscribe(x => {
      this.redirectPageCounter--;
      if (this.redirectPageCounter == 0) {
        redirectSubscriber.unsubscribe();
        this.redirectTo();
      }
    });
  }
  public redirectTo() {
    this.router.navigate(['/login']);
  }
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  private displayErrorMsg(type: string, msg: string) {
    if (type == 'error') {
      this.toastr.error(msg, 'Error', {
        timeOut: 3000
      });
    }
  }
  private clearSession() {
    sessionStorage.clear();
    localStorage.clear();
  }

  toggleConfirmFieldTextType() {
    this.confirmfieldTextType = !this.confirmfieldTextType;
  }

  keyPresspincode(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  keyPress(event: any) {
    const pattern = /^[^-\s][0-9 ]*$/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  // Only AlphaNumeric with Some Characters [-_ ]
  keyPressAlphaNumericWithCharacters(event) {

    var inp = String.fromCharCode(event.keyCode);
    // Allow numbers, alpahbets, space, underscore
    if (/[a-zA-Z-_ ]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  back(){
    this.router.navigate(['/login']);
  }
  
}
